import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=45526c5d"
import script from "./Attachment.vue?vue&type=script&lang=js"
export * from "./Attachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45526c5d')) {
      api.createRecord('45526c5d', component.options)
    } else {
      api.reload('45526c5d', component.options)
    }
    module.hot.accept("./Attachment.vue?vue&type=template&id=45526c5d", function () {
      api.rerender('45526c5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/islamicFinance/Attachment.vue"
export default component.exports